import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';

const pageSchema = PortalSettingsGetSchema.pages.mail;
const pageId = pageSchema.pageId;

function PortalSettingsMail({
    portalSettingsObject,
    setPortalSettingsData
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setPortalSettingsData([pageId, paramName], value);
    }, [setPortalSettingsData]);

    const mailSupport     = pageData[pageSchema.mailSupport];
    const mailSupportName = pageData[pageSchema.mailSupportName];

    return (
        <EditorLayout>
            <SMCTextInput
                value={mailSupport}
                onChange={e => setPageValue(pageSchema.mailSupport, e.target.value)}
                label={t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL')}
                tooltip={<>{t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE1')} <b>{t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE2')}</b> {t('SMP.SETTINGS.MAIL.REPLY_TO_EMAIL.TOOLTIP.LINE3')}</>}
            />
            <SMCTextInput
                value={mailSupportName}
                onChange={e => setPageValue(pageSchema.mailSupportName, e.target.value)}
                label={t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY')}
                tooltip={<>{t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE1')} <b>{t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE2')}</b> {t('SMP.SETTINGS.MAIL.REPLY_TO_FRIENDLY.TOOLTIP.LINE3')}</>}
            />
        </EditorLayout>
    )
}

export default PortalSettingsMail;